import { useCallback } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/apiConfig';

/**
 * Custom hook for utility rate API operations
 */
export const useUtilityRates = () => {
  const authToken = localStorage.getItem('authToken');

  const listRates = useCallback(async ({ page = 1, page_size = 50, search = '', sector = '', utility_name = '' }) => {
    const params = { page, page_size };
    if (search) params.search = search;
    if (sector) params.sector = sector;
    if (utility_name) params.utility_name = utility_name;

    const response = await axios.get(API_ENDPOINTS.getUtilityRates, {
      headers: { Authorization: `Token ${authToken}` },
      params,
    });

    return {
      rates: response.data.rates || [],
      total_pages: response.data.total_pages || 1,
      total_count: response.data.total_count || 0,
    };
  }, [authToken]);

  const listUtilities = useCallback(async ({ search = '', sector = '' }) => {
    const params = {};
    if (search) params.search = search;
    if (sector) params.sector = sector;

    const response = await axios.get(API_ENDPOINTS.getUtilityRateUtilities, {
      headers: { Authorization: `Token ${authToken}` },
      params,
    });

    return response.data.utilities || [];
  }, [authToken]);

  const getRateDetail = useCallback(async (rateId) => {
    const response = await axios.get(`${API_ENDPOINTS.getUtilityRateDetail}${rateId}/`, {
      headers: { Authorization: `Token ${authToken}` },
    });

    return response.data;
  }, [authToken]);

  const resolveDepotUtilityRates = useCallback(async ({ depotIds = [], selectedRateIds = {} }) => {
    const response = await axios.post(
      API_ENDPOINTS.fleetDepotUtilityRatesResolve,
      {
        depot_ids: depotIds,
        selected_rate_ids: selectedRateIds,
      },
      {
        headers: { Authorization: `Token ${authToken}` },
      }
    );

    return response.data?.depots || [];
  }, [authToken]);

  return {
    listRates,
    listUtilities,
    getRateDetail,
    resolveDepotUtilityRates,
    hasAuth: !!authToken,
  };
};

/**
 * Utility function to flatten URDB tiered structure for display
 */
export const flattenTieredStrux = (strux, tierKey) => {
  if (!Array.isArray(strux) || strux.length === 0) return [];
  const rows = [];

  strux.forEach((periodObj, periodIdx) => {
    const tiers = Array.isArray(periodObj)
      ? periodObj
      : periodObj?.[tierKey];
    if (!Array.isArray(tiers) || tiers.length === 0) return;

    tiers.forEach((tierObj, tierIdx) => {
      rows.push({
        period: periodIdx,
        tier: tierIdx,
        max: tierObj?.max,
        rate: tierObj?.rate,
        adj: tierObj?.adj,
        unit: tierObj?.unit,
      });
    });
  });

  return rows;
};
